module.exports = __webpack_public_path__ + "img/project_1.1b240483.png";